import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    // Stocker le message s'il existe dans l'état de la location
    const message = location.state?.message || "Veuillez vous connecter pour accéder à cette page";
    
    return (
      <Navigate 
        to="/login" 
        state={{ 
          from: location,
          message 
        }} 
        replace 
      />
    );
  }

  return <>{children}</>;
};

export default AuthGuard;